import React from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const Stats = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const stats = [
    { value: 10, suffix: "+", label: "Projects" },
    { value: 1000, suffix: "+", label: "Plots Sold" },
    { value: 15, suffix: "+", label: "Years Experience" },
    { value: 99, suffix: "%", label: "Client Satisfaction" },
  ];

  return (
    <section ref={ref} className="px-4">
       <div className="mt-16 text-center">
          <h2 className="text-2xl md:text-3xl font-light text-gray-900 mb-4">
            Our Stats
          </h2>
          <div className="w-24 h-0.5 bg-gray-300 mx-auto"></div>
        </div>
      <div className="max-w-6xl mx-auto md:py-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="mb-4 h-px bg-gray-200 w-16 mx-auto"></div>
              <h3 className="text-3xl md:text-4xl font-light text-gray-900 mb-2">
                {inView ? (
                  <CountUp
                    end={stat.value}
                    duration={2.5}
                    suffix={stat.suffix}
                    delay={index * 0.2}
                  />
                ) : (
                  `0${stat.suffix}`
                )}
              </h3>
              <p className="text-sm uppercase tracking-wider text-gray-500">
                {stat.label}
              </p>
              <div className="mt-4 h-px bg-gray-200 w-16 mx-auto"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
